import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà accepté les cookies
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50" data-testid="cookie-banner">
      <div className="container mx-auto max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-center sm:text-left">
          <p>
            Ce site utilise des cookies techniques essentiels pour son fonctionnement. 
            En continuant à naviguer, vous acceptez leur utilisation.{' '}
            <Link to="/confidentialite" className="underline hover:text-indigo-300">
              En savoir plus
            </Link>
          </p>
        </div>
        <Button 
          onClick={handleAccept}
          className="bg-indigo-600 hover:bg-indigo-700 whitespace-nowrap"
          data-testid="accept-cookies-btn"
        >
          J'accepte
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
